/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { CardContent } from '../../../Shared/Card'
import { Icon } from 'semantic-ui-react'

const NoNegativeActivityCardContent = () => {
    return (
      <CardContent
        className='card-content'
        css={css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            row-gap: 1rem;
        `}
      >
          <Icon name='checkmark' size='huge' color='green' />
          <p
            css={css`
                font-weight: bold;
                color: #22c55e;
            `}
          >Toutes les commandes ont été acquises !</p>
      </CardContent>
    )
}

export { NoNegativeActivityCardContent }
